<template>
  <div
    class="w-full h-full relative m-auto"
    :class="{ 'max-w-4xl': !isLoading && workflowEmptyList }"
  >
    <div class="heading pb-6">
      <div class="flex justify-between items-center">
        <div>
          <zt-button
            color="dark-400"
            icon="angle-left"
            text
            class="go-back"
            @click="goBack"
            data-vs-button="workflow-go-back"
          >
            {{
              $t(
                'message.main_bussines_page.workflow.configuration.buttonBack'
              )
            }}
          </zt-button>
          <div class="flex items-center">
            <h2 class="font-normal text-zt-primary-200">
              {{
                $t(
                  'message.main_bussines_page.workflow.workflow_creation'
                )
              }}
            </h2>
          </div>
        </div>
        <div v-if="!isLoading">
          <zt-button
            icon="plus-circle"
            @click="$router.push({ name: 'workflowCreate' })"
            data-vs-button="workflow-create"
          >
            {{
              $t(
                  'message.main_bussines_page.workflow.configuration.create'
              )
            }}
          </zt-button>
        </div>
      </div>
    </div>
    <div class="main bg-zt-white" :class="mainClasses">
      <div
        v-if="isLoading"
        class="absolute w-full top-0 left-0 h-full bg-zt-white"
      >
        <vue-element-loading
          :active="isLoading"
          spinner="spinner"
          duration="1.5"
          color="#4f4f4f"
          size="50"
        />
      </div>
      <div v-else>
        <div class="w-full">
          <workflow-empty v-if="workflowEmptyList" />
          <workflow-list-table v-else :rows="workflowList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowEmpty from '@/modules/Workflow/components/WorkflowEmpty'
import WorkflowListTable from "@/modules/Workflow/components/WorkflowListTable.vue";
import VueElementLoading from 'vue-element-loading'
import Workflow from '@/apiClient/Workflow'
export default {
  name: 'Workflow',
  components: {
    WorkflowEmpty,
    WorkflowListTable,
    VueElementLoading
  },
  data() {
    return {
      workflowInstance: new Workflow(),
      workflowEmptyList: true,
      isLoading: true,
      workflowList: []
    }
  },
  computed: {
    mainClasses() {
      if (this.isLoading) return ['h-custom']
      return this.workflowEmptyList ? ['h-auto', 'rounded', 'm-shadow'] : ['h-custom']
    }
  },
  async mounted() {
    await this.getWorkflowList()
  },
  methods: {
    workflowShownEmpty() {
      this.workflowEmptyList = this.workflowList.length === 0
      this.isLoading = false
    },
    goBack() {
      this.$router.push({ name: 'MainBusinessPage' })
    },
    async getWorkflowList() {
      try {
        const {
          data: { data }
        } = await this.workflowInstance.getWorkflowList()
        this.workflowList = data
      } catch (e) {}
      this.workflowShownEmpty()
    }
  }
}
</script>

<style scoped lang="scss">
.heading {
  h2 {
    color: #707070;
    font-size: 24px;
  }
}
.h-custom {
  height: calc(100% - 80px);
}
.m-shadow {
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.14), 0 3px 3px rgba(0, 0, 0, 0.12),
    0 1px 8px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
::v-deep {
  .zt-button.go-back {
    background: transparent !important;
    color: #777 !important;
    padding: 0 !important;
    font-size: 1rem;
  }
}
</style>
